import { render } from "./StatusSelect.vue?vue&type=template&id=63b0a8a8&scoped=true"
import script from "./StatusSelect.vue?vue&type=script&lang=js"
export * from "./StatusSelect.vue?vue&type=script&lang=js"

import "./StatusSelect.vue?vue&type=style&index=0&id=63b0a8a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b0a8a8"]])

export default __exports__